<script type="text/babel">
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreScrollOnPageBack from 'dashboard-js/mixins/RestoreScrollOnPageBack'

export default {
  mixins: [ManagesModalState, RestoreScrollOnPageBack],

  props: ['platforms', 'user', 'courses'],

  data() {
    return {
      instructors: {},
      lessons: [],
    }
  },

  computed: {
    instagram() {
      return this.platforms[0]
    },

    youtube() {
      return this.platforms[1]
    },

    analytics() {
      return this.platforms[2]
    },

    betterhype() {
      return {
        slug: 'betterhype',
      }
    },
  },

  created() {
    this.instructors = {
      betterhype: {
        name: 'betterhype',
        profile_photo_url:
            'https://yt3.googleusercontent.com/vnEGZh7dDvujukWCsFGg9mACM2c7JJfvG52jjT8Y3qMwce0GmyVNHQDKNQbffwkHjIMxnnMsUg=s160-c-k-c0x00ffffff-no-rj',
        channels: [
          {
            platform: this.youtube,
            resource_name: 'betterhypeapp',
            resource_url: 'https://www.youtube.com/@Betterhype-1',
          },
          {
            platform: this.analytics,
            resource_name: 'betterhype',
            resource_url: 'https://betterhype.com/',
          },
        ],
      },
    }

    this.lessons = this.courses.map(course => ({
      youtube_id: course.video_url.split('v=')[1],
      title: course.name,
      excerpt: '',
      description: course.description,
      cover_image: course.image,
      duration: '',
      platform: this.betterhype,
      instructor: this.instructors.betterhype,
    }))
  },

  methods: {
    becomeInstructor() {
      Bus.$emit('showSupportForm', {
        subject: 'Anmodning om at blive instruktør på brand-skolen',
        message:
            'Hej betterhype!\n' +
            '\n' +
            'Jeg er interesseret i at blive instruktør på jeres brand-skole.\n' +
            '\n' +
            'Hvordan kan jeg blive det?\n' +
            '\n' +
            'Med venlig hilsen\n' +
            this.user.name,
      })
    },
  },
}
</script>
